import { useCallback } from 'react';

import { useTracking as useTrackingBase } from '@change-corgi/core/react/tracking';

type Result = {
	trackCardFieldFocus: (field: 'cvc' | 'expiry' | 'number' | 'card') => void;
};

export function useTracking(): Result {
	const track = useTrackingBase();

	return {
		trackCardFieldFocus: useCallback(
			(field: 'cvc' | 'expiry' | 'number' | 'card') => {
				void track(`pp_focus_card_${field}`);
			},
			[track],
		),
	};
}
